import $ from 'jquery';

import { View } from 'backbone';
import { Model } from 'backbone';
import util from 'util/Util';
import _Template from 'designer/layout-toolbar-pane.ejs';
import Immutable from 'immutable';
import listService from 'ListService';
import eventBus from 'EventBus';
import pageSyncService from 'PageSyncService';
import constants from 'Constants';
import factoryService from 'FactoryService';
import dragDropService from 'DragDropService';
import restService from 'RestService';
import geometryService from 'GeometryService';
import AddAssetView from 'common-views/AddAssetView';
import CommonGroupConfigView from 'common-views/CommonGroupConfigView';
import groupAllTemplate from 'toolbox/toolbox-group.ejs';
import groupButtonTemplate from 'toolbox/toolbox-group.ejs';
import groupLayoutTemplate from 'toolbox/toolbox-group.ejs';
import groupInputemplate from 'toolbox/toolbox-group.ejs';
import groupAssetemplate from 'toolbox/toolbox-group-assets.ejs';
import groupContainersTemplate from 'toolbox/toolbox-group.ejs';
import groupCommonTemplate from 'toolbox/toolbox-group-common.ejs';
import toolboxDesignerTemplate from 'toolbox/toolbox-groups.ejs';
import toolboxTabsTemplate from 'toolbox/toolbox-tabs.ejs';
import assetCollection from 'AssetCollection';
import assetUI from 'AssetUI';
import formModel from 'formModel';
import zoomService from 'ZoomService';
import focusController from 'FocusController';
import groupController from 'GroupController';


import toolboxItemMapService from 'ToolboxItemMapService';

import crudController from 'CrudController';
import AccountService from 'AccountService';
import ConfirmDialogView from 'common-views/ConfirmDialogView';
import AlertDialogView from 'common-views/AlertDialogView';
import mobileDesignConfirmationModal from 'designer/modals/MobileDesignConfirmationModal';
import mobileDesignInformationModal from 'designer/modals/MobileDesignInformationModal';
import undoService from 'UndoService';
import textConstants from 'TextConstants';
import sequenceService from 'SequenceService.js';

import MobileMenuIcon from  '../components/MobileWizard/MobileMenuIcon';
import userService from "../service/UserService";
import mobileListService from '../service/mobile/MobileListService';
import groupService from '../service/GroupService';

class MobileToolbarPaneView extends View {
    initialize(opts) {

        this.defaultGroup = constants.DEFAULT_TOOLBOX_GROUP;
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #deleteItem': 'resetColumn',

            'click #designerView,#behaviorView,#workflowView, #mobileFormsView': 'handleLinkNavigation',
            'click .layout-switch': 'handleChangeLayout',
            'click .control-tabs li a': 'changeTabs',
            'click .asset_new': 'addAsset',
            'click .asset_delete': 'deleteAsset',

            /* PF-3527 Commented as it will be used on next versions.
             'click #zoom-in': 'zoomIn',
             'click #zoom-out': 'zoomOut',
             'click #fit-to-window': 'fitToWindow',
             'click #actual-size': 'actualSize',
            */

            'click #group,#unGroup': 'groupingUngrouping',
            'click .asset': 'assetClicked',
            'click #common_config': 'commonConfig',
            'click #undoAction': 'undoAction',
            'click #redoAction': 'redoAction',
            'drop #toolSearch': 'avoidDragAndDrop',
            'click #workflowmain': 'workflowmain',
            'click #behaviors': 'behaviors',
            'dblclick .asset p': 'showFieldAssetName',
            'keyup .edit-asset-name': 'changeAssetName',
            'focusout .edit-asset-name': 'changeAssetName'
        };

        this.templateMap = Immutable.Map([
            ['all', groupAllTemplate],
            ['buttons', groupButtonTemplate],
            ['layout', groupLayoutTemplate],
            ['input', groupInputemplate],
            ['assets', groupAssetemplate],
            ['containers', groupContainersTemplate],
            ['common', groupCommonTemplate]
        ]);

        // PF-1333
        this.selectedGroupElement = this.defaultGroup;
        this.toolboxItems = toolboxItemMapService.getLayoutItemsByGroup('all');
        this.model.set('helpUrl', constants.HELP_LAYOUT_TOOLBAR_URL);
        this.model.set('helpUrl2', constants.HELP_LAYOUT_URL);

        this.listenTo(eventBus, 'assetAdded', this.showAssets);
        this.listenTo(eventBus, 'commonGroupUpdated', this.commonGroupUpdated);
        this.listenTo(eventBus, 'changeMobileLayout', this.showMobileLayout);

        if (!util.hasEventListener(eventBus._events, 'drawToolBarOnResizeWindow')) {
            this.listenTo(eventBus, 'drawToolBarOnResizeWindow', this.setSelectedGroup);
        }

        return this;
    }

    resetColumn(){
        const pageID = listService.currentPageId;
        const existsSecondColumn = listService.existSecondColumnConfigurationByPage(pageID);

        if(existsSecondColumn && mobileListService.mobileCurrentColumnView !== constants.ONE_COLUMN_VIEW_DROPDOWN_TEXT){
            eventBus.trigger(constants.EV_RESET_COLUMN_PER_PAGE);
        }
    }

    workflowmain(ev) {
        ev.preventDefault();
        Backbone.history.loadUrl('workflowmain');
    }

    behaviors(ev) {
        ev.preventDefault();
        Backbone.history.loadUrl('behaviors');
    }

    handleLinkNavigation(ev){
        listService.itemSearched = 0;
        listService.linkClicked = true;
    }

    avoidDragAndDrop() {
        return false;
    }

    undoAction() {
        undoService.undo();
        eventBus.trigger('undoCacheEvent');
    }

    redoAction() {
        undoService.redo();
        eventBus.trigger('undoCacheEvent');
    }

    deleteAssetCallback(result) {
        eventBus.trigger('assetDeletedEvent', 'ASSET', result.assetId);
    }

    addAsset(ev) {
        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(this.selectedGroupElement);
        assetUI.showLabelAssetName();
        const view = new AddAssetView({ model: this.model });
        view.render();
    }

    deleteAsset() {
        if (!listService.selectedAsset) {
            return;
        }

        assetUI.deleteAsset(this);
    }

    execDeleteAsset() {
        const
            confirmText = 'Are you sure you want to delete this asset?',
            confirmTitle = 'Delete Asset',
            confirmSuccess = () => {
                restService.deleteAsset(listService.selectedAsset.id, this.deleteAssetCallback);

                assetCollection.remove(listService.selectedAsset.id);
                listService.clearSelected();
                this.showAssets();

                eventBus.trigger('selectPage');
            },

            confirmView = new ConfirmDialogView({
                model: new Model({
                    text: confirmText,
                    success: confirmSuccess,
                    title: confirmTitle,
                    height: 125, with: 400
                })
            });

        confirmView.render();

    }

    assetClicked(ev) {
        if (ev.type === "click") {
            assetUI.assetClicked(ev, this);
        }
    }

    showFieldAssetName(ev) {
        assetUI.showFieldAssetName(ev);
    }

    changeAssetName(ev) {
        assetUI.changeAssetName(ev);
    }

    commonConfig(ev) {
        const view = new CommonGroupConfigView({ model: this.model });
        view.render();
    }

    filterControls(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;

        //console.log(buttonName);

        // Clear current selection
        $('.control-groupbar div').removeClass('control-group-selected');

        // remove controls from list
        $('.factory-widget').addClass('hide');
        $('#asset_new').addClass('hide');
        $('#factories .asset').remove();

        if (buttonName === "groupAll") {
            $('#control_text').removeClass('hide');
            $('#control_small_text').removeClass('hide');
            $('#control_large_heading').removeClass('hide');
            $('#control_medium_heading').removeClass('hide');
            $('#control_small_heading').removeClass('hide');
            $('#control_picture').removeClass('hide');
            $('#control_button').removeClass('hide');
            $('#control_submit_button').removeClass('hide');
            $('#control_page_button').removeClass('hide');
            $('#control_group').removeClass('hide');
            $('#control_text_input').removeClass('hide');
            $('#control_multiple_text_input').removeClass('hide');
            $('#control_numeric_input').removeClass('hide');
            $('#control_date_input').removeClass('hide');
            $('#control_time_input').removeClass('hide');
            $('#control_date_calendar').removeClass('hide');
            $('#control_checkbox_group').removeClass('hide');
            $('#control_checkbox').removeClass('hide');
            $('#control_radio_button_group').removeClass('hide');
            $('#control_radio_button').removeClass('hide');
            $('#control_drop_down').removeClass('hide');
            $('#control_list').removeClass('hide');
            $('#control_bullet_text').removeClass('hide');
            $('#control_vertical_separator').removeClass('hide');
            $('#control_horizontal_separator').removeClass('hide');
            $('#control_sound').removeClass('hide');
            $('#control_movie').removeClass('hide');
            $('#control_link').removeClass('hide');
            $('#control_progress_bar').removeClass('hide');
            $('#control_timer').removeClass('hide');
            $('#control_print_button').removeClass('hide');
            $('#control_captcha').removeClass('hide');
            $('#control_mask_text_input').removeClass('hide');
            $('#control_numeric_stepper').removeClass('hide');
            $('#control_password_input').removeClass('hide');
            $('#control_file_attachment').removeClass('hide');
            $('#control_image_input').removeClass('hide');
            $('#control_websignature').removeClass('hide');
            $('#control_vertical_slider').removeClass('hide');
            $('#control_horizontal_slider').removeClass('hide');
            $('#control_table').removeClass('hide');
            $('#control_ranking').removeClass('hide');
            $('#control_play_form_button').removeClass('hide');
            $('#control_play_report_button').removeClass('hide');
            $('#factories .scroll-pane').css('width', '4700px');

        }

        if (buttonName === "groupInput") {
            $('#control_text_input').removeClass('hide');
            $('#control_multiple_text_input').removeClass('hide');
            $('#control_numeric_input').removeClass('hide');
            $('#control_date_input').removeClass('hide');
            $('#control_time_input').removeClass('hide');
            $('#control_date_calendar').removeClass('hide');
            $('#control_checkbox_group').removeClass('hide');
            $('#control_checkbox').removeClass('hide');
            $('#control_radio_button_group').removeClass('hide');
            $('#control_radio_button').removeClass('hide');
            $('#control_drop_down').removeClass('hide');
            $('#control_captcha').removeClass('hide');
            $('#control_mask_text_input').removeClass('hide');
            $('#control_numeric_stepper').removeClass('hide');
            $('#control_password_input').removeClass('hide');
            $('#control_file_attachment').removeClass('hide');
            $('#control_image_input').removeClass('hide');
            $('#control_table').removeClass('hide');
            $('#control_ranking').removeClass('hide');
            $('#factories .scroll-content').css('width', '2000px');

        }

        if (buttonName === "groupAssets") {
            $('#asset_new').removeClass('hide');
            $('#factories .scroll-content').css('width', '100%');
            this.showAssets();
        }

        if (buttonName === "groupButtons") {
            $('#control_button').removeClass('hide');
            $('#control_submit_button').removeClass('hide');
            $('#control_page_button').removeClass('hide');
            $('#control_play_report_button').removeClass('hide');
            $('#control_play_form_button').removeClass('hide');
            $('#control_print_button').removeClass('hide');
            $('#factories .scroll-content').css('width', '100%');

        }

        if (buttonName === "groupContainers") {
            $('#control_group').removeClass('hide');
            $('#control_checkbox_group').removeClass('hide');
            $('#control_radio_button_group').removeClass('hide');
            $('#factories .scroll-content').css('width', '100%');

        }

        $('#' + buttonName).addClass('control-group-selected');

    }

    handleChangeLayout(ev) {
       ev.preventDefault();
        const target = ev.currentTarget;
        const layoutType = target.getAttribute('data-layout');
        listService.linkClicked = true;

        if (layoutType === 'deviceDesktop') {
            eventBus.trigger('gridSizeSet',util.isTrue(userService.userSettings.attributes._edShGrid));
            Backbone.history.loadUrl('edit');
        }

        if (listService.noPages){
            eventBus.trigger('hideCanvas');
        } else {
            eventBus.trigger('showCanvas');
        }
       
        $('#desktop-toolbar').css('display', 'block');
        $('#mobile-toolbar').css('display', 'none');        
    }

    showMobileLayout() { 
        $('#desktop-toolbar').css('display', 'none');
        $('#mobile-toolbar').css('display', 'block');
        //leave the trash icon alive - top right 
        let tools = $('.views-container-zoom .toolMarginTop li:not(:nth-child(5))');
        tools.css('display', 'none');

        $('#property-tabs > .nav-tabs li:nth-child(3)').css('display', 'none');

        $('#property-tabs > .nav-tabs li:nth-child(2)').css('display', 'none');
    }

    hideStyles() {

    }

    changeLayout(target, layoutType, currentForm) {
        formModel.set({
            currentDevice: layoutType
        });

        if (layoutType === 'deviceTablet' || layoutType === 'devicePhone') {
            currentForm.model.set('responsive', true);
        }

        this.cleanUpLayoutSwitches();
        this.drawLayout(layoutType);
        
        if (target) {
            $(target).addClass('active');
        }         

        //eventBus.trigger('selectForm');
    }

    cleanUpLayoutSwitches() {
        const layoutSwitches = this.$el.find('.layout-switch');
        layoutSwitches.map((index, item) => {
            $(item).removeClass('active')
        })
    }

    drawLayout(layoutType) {
        // Getting the current width either the one by default or the one assigned by the user via properties.
        //let currentWidth=listService.currentForm.model.attributes.formWidth;
        //let currentHeight=listService.currentForm.model.attributes.formHeight;

        let currentWidth = listService.currentForm.model.get('formWidth');
        let currentHeight = listService.currentForm.model.get('formHeight');


        const mapSizes = Immutable.Map([
            ['deviceDesktop', { width: currentWidth, height: currentHeight }],
            ['deviceTablet', { width: constants.TABLET_MAX_WIDTH, height: constants.TABLET_MAX_HEIGHT }],
            ['devicePhone', { width: constants.PHONE_MAX_WIDTH, height: constants.PHONE_MAX_HEIGHT }]
        ]);
        var newSize = mapSizes.get(layoutType);
        var newHeight = newSize.height;
        var newWidth = newSize.width;


        // Saving the current layout type inside the current model of the form.
        // This is perfomed to validate the bounds of a control in the PageSyncService.


        listService.currentForm.model.set('formHeight', newHeight, { silent: true });
        listService.currentForm.model.set('formWidth', newWidth, { silent: true });

        eventBus.trigger('formWidthSet', newWidth);
        eventBus.trigger('formHeightSet', newHeight);
        var currPage = listService.currentPageId;
        listService.currentPageId = 0;
        pageSyncService.displayPage(currPage);

        $('ul.views-options a.layout-switch').removeClass('active');
        $('ul.views-options a.layout-switch[data-layout="' + layoutType + '"]').addClass('active');

        listService.currentForm.model.trigger('change');
        eventBus.trigger('gridWidthSet', 20);
        eventBus.trigger('gridHeightSet', 20);

        // select the current control
        //$('#' + listService.currentId + ' div.pf-control-core').trigger('click');
    }

    showAssets() {
        assetUI.showAssets();
        assetUI.attachRightClickMenu(this);
        this.delegateEvents();
    }

    // PF-3527 Commented as it will be used on next versions.
    /*
    zoomIn(evt) {
        evt.preventDefault();
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_IN);
        let canZoom = zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_IN);
        if (canZoom) {
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_IN);
        }

    }

    zoomOut(evt) {
        evt.preventDefault();

        let canZoom = zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_OUT);
        if (canZoom) {
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_OUT);
        }
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_OUT);
    }
    */


    groupingUngrouping() {
        groupController.toggleGroup(listService.selected);
    }

    fitToWindow(evt) {
        evt.preventDefault();
        zoomService.handleFitToWindow();
    }

    actualSize(evt) {
        evt.preventDefault();
        listService.currentForm.model.attributes.zoomScale = undefined;
        const layoutType = formModel.attributes.currentDevice;
        this.drawLayout(layoutType);
    }

    changeTabs(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;
        const tabSectionName = ev.currentTarget.name;

        this.setSelectedGroup(tabSectionName);

    }

    commonGroupUpdated() {
        this.setSelectedGroup('common');
    }

    setSelectedGroup(sectionName, execContext = this) {
        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(sectionName);
        let context = execContext;
        this.selectedGroupElement = sectionName;

        const items = toolboxItemMapService.getLayoutItemsByGroup(sectionName);

        if (sectionName === 'common' && items.length) {
            let layoutItems = toolboxItemMapService.getLayoutItemsByGroup('all');

            items.forEach(i => {
                let control = layoutItems.find(c => c.factoryKey === i.factoryKey);
                if (control) {
                    if (control.style) {
                        i.style = control.style;
                    }

                    if (control.textStyle) {
                        i.textStyle = control.textStyle;
                    }
                }
            });
        }

        context.model.set('items', items, { silent: true });

        // reset all tab panes
        $('#factories .tab-pane').empty();

        // insert template for selected group
        const gTemplate = context.templateMap.get(sectionName);

        $('#' + sectionName).html(gTemplate(this.model.toJSON()));
        if ((items.length + 1) < constants.MAX_ITEMS_PER_SECTION_TOOLBAR) {
            $(".left.carousel-control").addClass("disable_a_href");
            $(".right.carousel-control").addClass("disable_a_href");
        }

        if (sectionName === 'assets') {
            context.showAssets();
        }
        // TODO - Custom Load Common Items - TBD
    }

    //============================================
    // mimic the focusController switchProps method
    // assets wont be stored within the ListService like the other controls
    // so that's the reason for placing this code here.
    //============================================

    toolboxItemMatcher(toolboxItems) {
        return function findMatches(q, cb) {
            var matches, substringRegex;

            matches = [];
            let val = $('#toolSearch').val();
            substringRegex = new RegExp(val, 'i');
            $.each(toolboxItems, function (i, toolboxItem) {
                if (substringRegex.test(toolboxItem.name)) {
                    let obj = toolboxItem;
                    obj.label = toolboxItem.name;
                    obj.factoryKey = toolboxItem.factoryKey;
                    if (dragDropService.isFeatureEnabledForControl(obj.factoryKey)) {
                        matches.push(obj);
                    }
                }
            });
            cb(matches);
        };
    }

    createControl(factoryKey, position) {

        if (dragDropService.isFeatureEnabledForControl(factoryKey)) {
            const factoryParams = factoryService.factories[factoryKey];

            let dropPos = {
                top: position.top,
                left: position.left
            };

            // The factory knows to create properties for the model
            const isGroup = constants.GROUPS_CONTROLS_KEYS.includes(factoryKey);
            this.control = !isGroup ? factoryParams.factory.createView(factoryKey, dropPos) : groupService.createNewGroup(factoryKey, dropPos);
            //Validation to know if original drop position is valid
            //also validates if is a valid overlapping (at least 50% of the control over the page)
            this.control.validateToStayInBounds(this.control.model, true);
            if (this.control.model.get('invalid') === false) {
                dropPos = dragDropService.modifyControlOnEdgeDrop(dropPos, {
                    width: util.extractNum(this.control.model.get('width')),
                    height: util.extractNum(this.control.model.get('height'))
                });

                this.control.model.attributes.top = dropPos.top;
                this.control.model.attributes.left = dropPos.left;

                let grpVw = null;
                const dropGrpRect = {
                    top: position.top,
                    left: position.left,
                    width: 1,
                    height: 1,
                    id: this.control.model.get('id')
                };
                // The control should be added to a group
                grpVw = dragDropService.droppedOnGroupObject(dropGrpRect);

                if (grpVw) {
                    groupService.addControlToGroup(grpVw, this.control, dropPos);

                    // PF-2524: Update parent's minimu width and height based on it's children
                    let newMinWidth = grpVw.model.get('minWidth');
                    let newMinHeight = grpVw.model.get('minHeight');
                    grpVw.model.get('childList').forEach(o => {
                        let tmpWidth = util.extractNum(o.get('left')) + util.extractNum(o.get('width'));
                        let tmpHeight = util.extractNum(o.get('top')) + util.extractNum(o.get('height'));
                        if (tmpWidth > newMinWidth) {
                            newMinWidth = tmpWidth;
                        }
                        if (tmpHeight > newMinHeight) {
                            newMinHeight = tmpHeight;
                        }
                    });

                    if (grpVw.model.get('minWidth') < newMinWidth) {
                        grpVw.model.set('minWidth', newMinWidth, { silent: true });
                    }
                    if (grpVw.model.get('minHeight') < newMinHeight) {
                        grpVw.model.set('minHeight', newMinHeight, { silent: true });
                    }
                }

                // PF-1301: Adding digit part/control number to control name when dropping from the search box
                sequenceService.tabIndexParentId = listService.currentPageId;
                if (sequenceService.getControlNumber() < 0) {
                    sequenceService.initControlNumber();
                }
                sequenceService.addControlNumber();
                this.control.model.set('name', this.control.model.get('name') + ' ' + sequenceService.getControlNumber(), constants.MODEL_SILENT);

                listService.addObject(this.control.id, this.control);
               
                this.control.render();

                // Check if zoom
                if (listService.currentForm.model.attributes.zoomScale) {
                    zoomService.handleSpecificControlZoom(listService.currentForm.model.attributes.zoomScale, this.control.id);
                    // Placing the real position where the control is placed when its dropped inside the canvas and it is on zoomed mode.
                    this.control.model.attributes.top = this.control.model.attributes.top / listService.currentForm.model.attributes.zoomScale;
                    this.control.model.attributes.left = this.control.model.attributes.left / listService.currentForm.model.attributes.zoomScale;
                }


                // Mark the control -- only happens at creation drop. Subsequent focus change un-marks the control
                //focusController.markControl(control.id, true);
                listService.currentId = this.control.model.get('id');

                // Paint the properties
                //focusController.switchPropsViews();
                $('#' + listService.currentId + ' div.pf-control-core').trigger('click');
                $('#' + listService.currentId).focus();

                /* Rene Lopez 22/02/2018
                ** PF-3485 Leaving this code as reference as it didn't work out for me while applying UNDO/REDO scenarios for groups.**
                ** PLEASE REVIEW AND LET ME KNOW IF YOU RECOGNIZE SOMETHING THAT MIGHT IMPACT THE APPLICATION.**
                        Findings:
                        crudController.deleteObject() !== listService.destroyObject()
                        listService.injectObject() !== listService.addObject()
                        Both destroyObject() and addObject() worked for me on Undo New as is the only place where the oldest functions were used.


                        There are two createControls:
                        DragDropService.createControl() and ToolbarPaneView.createControl()
                        Don't know if they could be one.
                 undoService.add({
                     undo: () => {
                         crudController.deleteObject(this.control, this.control.id, false);
                         if (childList) {
                             this.control.model.set('childList', childList, { silent: true });
                             _.forEach(childList, child => {
                                 $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['delete', 'object', child.get('id'), '', this.control._pageId]);
                             });
                         }
                     },
                     redo: () => {
                         this.control.listenTo(this.control.model, 'change', this.control.render);
                         if (childList) {
                             this.control.model.set('childList', childList, { silent: true });
                             _.forEach(childListView, child => {
                                 child.listenTo(child.model, 'change', child.render);
                                 listService.injectObject(child, { silent: true });
                             });
                         }

                         this.control.render();
                         listService.injectObject(this.control, { silent: true });
                          $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['add', 'object', this.control.model.get('id'),
                             this.control.model.get('name'), this.control._pageId]);
                     }
                 }, textConstants.UNDO_NEW);

                */

                window.setTimeout(() => {
                    $(constants.ID_SEL + this.control.id).trigger(constants.EV_CLICK + focusController.namespace);
                    util.updateHelpDocumentationLink(this.control.model.get('factoryKey'));
                }, 0);
            } else {
                console.log('element out of boundaries');
            }

            // Note: listenForInstanceDragStart() called by pageView
            //dragDropService.listenForDrop(constants.ID_SEL + this.control.id);
        }
    }

    render() {
        var self = this;
        this.$el.empty(); 
         
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $("#toolSearch").on('keypress', function (e) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code === 13) { //Enter keycode
                return false;
            }
        });

        $('#toolbox-tabs').html(toolboxTabsTemplate);
        $('#factories').html(toolboxDesignerTemplate);

        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(this.selectedGroupElement);        
        this.setSelectedGroup(this.selectedGroupElement);
        
        let selected = false;
        let initialEdges = {};

        if (listService.mainKind === 'R' && !listService.resizeWhenTooling) {
            listService.resizeWhenTooling = true;
            $(window).on('resize', (e) => {
                if (self.selectedGroupElement === 'assets') {
                    let maxItems = assetUI.calculateItemsPerSlide(self.selectedGroupElement);
                    if (maxItems !== constants.maxItemOnSlide) {
                        constants.maxItemOnSlide = maxItems;
                        eventBus.trigger('drawToolBarOnResizeWindow', self.selectedGroupElement, self);
                    }
                }
            });
        }

         
        let toolSearch = $("#toolSearch");
        if (toolSearch.length) {
                toolSearch.autocomplete({
                    source: this.toolboxItemMatcher(this.toolboxItems),
                    close: function (event, ui) {
                        if (!selected) {
                            $("ul.ui-autocomplete").hide()
                        }
                    },
                    focus: function (event, ui) {
                        let factoryKey = ui.item.factoryKey;
                        let menuItems = $('li.ui-menu-item div:contains("' + ui.item.value + '")');
        
                        initialEdges.left = event.pageX;
                        initialEdges.top = event.pageY;
                        initialEdges.right = event.pageX + event.currentTarget.clientWidth;
                        initialEdges.bottom = event.pageY + event.currentTarget.clientHeight;
        
                        let canvas = $(constants.PAGESEL_ID);
                        let pageRect = {
                            top: -1,
                            left: -1,
                            height: util.extractNum(canvas.height()) + 2,
                            width: util.extractNum(canvas.width()) + 2
                        };
        
                        _.forEach(menuItems, item => {
                            let modelItem = ui.item;
        
                            $(item).draggable({
                                containment: "body",
                                scroll: false,
                                helper: function (ev) {
                                    // Reset drag image
                                    focusController.clearAllSelected();
                                    let factories = factoryService.factories;
                                    // Identify the factory whose icon is being dragged
                                    // IE9 must use currentTarget instead of target. Works with others also.
                                    let iconId = modelItem.icon;
                                    //PF-2486 - Form Design - Layout - Cannot Drag Asset onto canvas
                                    const assetId = ev.target.getAttribute("data-asset-id");
                                    const controlType = modelItem.factoryKey;
        
                                    if (controlType) { //If factory is for an asset then controlType brings us the iconId (Control type)
                                        iconId = controlType;
                                    }
                                    const height = factories[iconId].height;
                                    const width = factories[iconId].width;
        
                                    const dragImage = dragDropService.createRawDragGhost(height, width);
                                    const $ghost = dragImage.$ghost;
                                    // Second: get center point. We drag the center of the drag ghost
                                    let cx = $ghost.width() / 2;
                                    let cy = $ghost.height() / 2;
                                    return $ghost.get(0);
                                },
                                start: function (ev, ui) {
        
                                    let position = {
                                        left: Math.floor(ui.helper.width() / 2),
                                        top: Math.floor(ui.helper.height() / 2)
                                    };
        
                                    $(this).draggable('instance').offset.click = position;
                                },
                                drag: function (event, ui) {
                                    if (((ui.position.top + ui.helper.height() < (initialEdges.top - (ui.helper.height() / 2))) ||
                                        ((ui.position.top + ui.helper.height()) > initialEdges.bottom - (ui.helper.height() / 2))) ||
                                        (((ui.position.left + ui.helper.width()) < (initialEdges.left - (ui.helper.width() / 2))) ||
                                            (ui.position.left + ui.helper.width()) > (initialEdges.right - (ui.helper.width() / 2)))) {
        
                                        selected = true;
        
                                        $("ul.ui-autocomplete").hide();
                                        $("#toolSearch").val('');
                                    }
        
                                    let elemRect = {
                                        left: Number(ui.position.left - util.pagePos.left),
                                        top: Number(ui.position.top - util.pagePos.top),
                                        width: util.extractNum(ui.helper.width()),
                                        height: util.extractNum(ui.helper.height())
                                    };
        
                                    let isInsideCanvas = geometryService.isValidOverlapping(pageRect, elemRect);
                                    let cursor = isInsideCanvas ? "copy" : 'no-drop';
        
                                    $(ui.helper).css('cursor', cursor);
                                },
                                stop: function (event, ui) {
                                    // Drop point relative to document object
                                    let p = dragDropService.align(event.originalEvent.pageX, event.originalEvent.pageY);
        
                                    let position = dragDropService.align(
                                        p.x - util.pagePos.left - event.originalEvent.offsetX,
                                        p.y - util.pagePos.top - event.originalEvent.offsetY);
        
                                    self.createControl(factoryKey, { top: position.y, left: position.x });
        
                                    selected = false;
        
                                    $(ui.helper).css('cursor', "pointer");
        
                                    const childList = [];
                                    const childListView = [];
                                    if (self.control.model.get('childList')) {
                                        _.forEach(self.control.model.get('childList'), child => {
                                            childList.push(child);
                                            childListView.push(listService.getObject(child.get('id')));
                                        });
                                    }
                                    undoService.add({
                                        undo: () => {
                                            if (self.control.model.get('childList')) {
                                                self.control.model.set('childList', childList, { silent: true });
                                                _.forEach(self.control.model.get('childList'), child => {
        
                                                    //PF-3485 Deleting the event raise, as destroy object will do the work.
                                                    listService.destroyObject(child.id, { silent: false });
                                                })
                                            }
                                            listService.destroyObject(self.control.id, { silent: false });
                                            self.control.unrender();
                                        },
                                        redo: () => {
                                            listService.addObject(self.control.id, self.control, { pageId: self.control.model.get('pageId') });
                                            self.control.listenTo(self.control.model, 'change', self.control.render);
                                            self.control.render();
        
                                            // PF-4477 Handling for Radio Button Group and Checkbox Group.
                                            if(util.isGroupContainer(self.control.model.get('factoryKey'))){
                                                self.control.listenTo(eventBus,'GroupPropertyChange',self.control.render);
                                                self.control.listenTo(eventBus,'GroupThemeChange',self.control.themeChangeRender);
                                            }
                                            if (childList) {
                                                self.control.model.set('childList', childList, { silent: true });
                                                _.forEach(childListView, child => {
                                                    child.listenTo(child.model, 'change', child.render);
                                                    listService.addObject(child.id, child, { pageId: child.model.get('pageId') });
                                                    child.render();
                                                });
                                            }
                                        }
                                    }, textConstants.UNDO_NEW);
                                }
                            });
                        });
                    }
                }).autocomplete('instance')._renderItem = function (ul, item) {
                    return $("<li>")
                        .append("<div><span><i class='fa " + item.icon + "'></i></span>" + item.label + "</div>")
                        .appendTo(ul);
        
        
                };
        } 

        // Required delegate events so toolbar actions can be performed.
        this.delegateEvents();

        // Mobile forms wizard.

        if (userService.checkFeatures("MobileViews")) {            
            MobileMenuIcon.render('mobileFormsView', { activeTab: listService.activeDashboardTab });
        } else {
            document.getElementById("mobileFormsView").remove();
        }
    }
 

    remove() {
        if (this.control) {
            this.control.remove();
            dragDropService.unlistenForDrop(constants.ID_SEL + this.control.id);
        }

        $('#toolSearch').unbind('typeahead:selected');
        this.$el.empty();
        this.undelegateEvents();
        this.off();

        super.remove();
    }
}

export default MobileToolbarPaneView;
